// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{margin:0;font-family:"Nunito",sans-serif}`, "",{"version":3,"sources":["webpack://./src/styles/core.scss"],"names":[],"mappings":"AAAA,KACE,QAAA,CACA,+BAAA","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Nunito', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
